import React from "react";
import {
  Grid,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  IconButton,
  FormHelperText,
  Tooltip,
} from "@mui/material";
import InfoIcon from "@mui/icons-material/Info";

export const bank_fields = [
  {
    label: "Bank Name",
    name: "Iban",
    type: "text",
    shrink: true,
    // maxLength: 40,
    required: false,
    helperText: "Name of the bank",
  },
  {
    label: "Bank Address",
    name: "address",
    type: "text",
    shrink: true,
    // maxLength: 32,
    required: false,
    helperText: "Physical address of the bank branch",
  },
  {
    label: "Account Number",
    name: "accountNumber",
    type: "text",
    shrink: true,
    // maxLength: 18,
    required: false,
    helperText: "Iso's bank account number",
  },
  {
    label: "Routing Number",
    name: "routingNumber",
    type: "text",
    shrink: true,
    // maxLength: 12,
    required: false,
    helperText: "ABA routing number (US) or sort code (UK)",
  },
];

const BankFields = ({
  formValues,
  handleChange,
  handleBlur,
  setFieldValue,
  errors,
  touched,
}) => {
  return (
    <>
      {bank_fields.map((field) => {
        const isRequired =
          typeof field.required === "function"
            ? field.required(formValues)
            : field.required;

        // Obtener el valor actual del campo
        const fieldValue = formValues.bank?.[field.name] || "";

        // Determinar el path del campo para errores y touched
        const fieldPath = `bank.${field.name}`;
        const fieldError = fieldPath
          .split(".")
          .reduce((obj, key) => obj?.[key], errors);
        const fieldTouched = fieldPath
          .split(".")
          .reduce((obj, key) => obj?.[key], touched);

        const isError = Boolean(fieldTouched && fieldError);
        const helperText =
          fieldTouched && fieldError ? fieldError : field.helperText || "";

        return (
          <Grid item xs={12} sm={3} key={field.name}>
            {field.type === "select" ? (
              <FormControl fullWidth required={isRequired} error={isError}>
                <InputLabel id={`${field.name}-label`}>
                  {field.label}
                </InputLabel>
                <Select
                  labelId={`${field.name}-label`}
                  name={fieldPath}
                  label={field.label}
                  value={fieldValue}
                  onChange={handleChange}
                  onBlur={handleBlur}
                >
                  {field.options?.map((option) => (
                    <MenuItem key={option} value={option}>
                      {option}
                    </MenuItem>
                  ))}
                </Select>
                <FormHelperText>{helperText}</FormHelperText>
              </FormControl>
            ) : (
              <TextField
                label={
                  <>
                    {field.label}
                    {field.helperText && !isError && (
                      <Tooltip title={field.helperText} arrow>
                        <IconButton
                          size="small"
                          sx={{ padding: 0, marginLeft: "4px" }}
                        >
                          <InfoIcon color="primary" fontSize="small" />
                        </IconButton>
                      </Tooltip>
                    )}
                  </>
                }
                name={fieldPath}
                value={fieldValue}
                onChange={handleChange}
                onBlur={handleBlur}
                InputLabelProps={{
                  shrink: field.shrink,
                  sx: {
                    "& .MuiFormLabel-asterisk": {
                      color: "red",
                      fontSize: "1.2rem",
                    },
                  },
                }}
                inputProps={{ maxLength: field.maxLength }}
                required={isRequired}
                type={field.type}
                error={isError}
                helperText={helperText}
                fullWidth
              />
            )}
          </Grid>
        );
      })}
    </>
  );
};

export default BankFields;
